// 이소혜 추가
<template>
  <div class="pop-terms-wrap">
    <div class="pop-terms-header">
      <div class="title">{{name}}</div>
      <div class="close" @click="termsToggleChange">닫기</div>
    </div>
    <div class="pop-terms-body">
       <EnhancedPdfViewer ref="pdfViewer" :name="name" :url="url" :initial-scale="1.0" @error="handleError" />
         <!-- <div style="height: 98vh"> -->
          <!-- <button @click="interact" type="=:button">Interact with page</button> -->
          <!-- <VuePdfApp @after-created="afterCreated" page-scale="100" :pdf="url" /> -->
    </div>
  </div>
</template>

<script>
import EnhancedPdfViewer from './EnhancedPdfViewer.vue'
import VuePdfApp from 'vue-pdf-app'

export default {
  components: {
    EnhancedPdfViewer
    // VuePdfApp
  },
  watch: {
    url (newVal, oldVal) {
      if (newVal) {
        // url이 바뀌면 한글화 메서드 호출
        this.$nextTick(() => {
          this.setVuePdfToKo()
        })
      }
    }
  },
  data () {
    return {
      content: '',
      name: '',
      url: '',
      testUrl: 'https://dpartner.modnpay.kr/pdfjs/web/viewer.html?file=https://dpartner.modnpay.kr/policyView?seq=14'
    }
  },
  methods: {
    async interact () {
      if (!this.pdfjs) return

      await this.pdfjs.pdfViewer.pagesPromise
      console.log(document.querySelectorAll('.page'))
    },
    afterCreated (pdfjs) {
      // non-reactive
      this.pdfjs = pdfjs
      window._pdf = pdfjs
    },
    setVuePdfToKo () {
    // Find bar placeholder
      const findInput = document.getElementById('findInput')
      if (findInput) findInput.placeholder = '문서에서 찾기…'

      // Previous / Next 버튼
      const findPrevious = document.getElementById('findPrevious')
      if (findPrevious) findPrevious.querySelector('span').textContent = '이전'

      const findNext = document.getElementById('findNext')
      if (findNext) findNext.querySelector('span').textContent = '다음'

      // 옵션 체크박스 라벨
      const highlightAllLabel = document.querySelector('label[for="findHighlightAll"]')
      if (highlightAllLabel) highlightAllLabel.textContent = '모두 강조'

      const matchCaseLabel = document.querySelector('label[for="findMatchCase"]')
      if (matchCaseLabel) matchCaseLabel.textContent = '대소문자 구분'

      const entireWordLabel = document.querySelector('label[for="findEntireWord"]')
      if (entireWordLabel) entireWordLabel.textContent = '단어 전체 일치'

      // 결과 표시
      const resultsCount = document.getElementById('findResultsCount')
      if (resultsCount) resultsCount.textContent = '총 5건 중 5건'
    },
    termsToggleChange () {
      this.$emit('termsToggleChange')
    },
    setTerm (term) {
      const { name, url } = term
      this.name = name
      this.url = url

      // PDF 뷰어의 줌 초기화
      this.$nextTick(() => {
        if (this.$refs.pdfViewer) {
          this.$refs.pdfViewer.resetZoom()
        }
      })
      // this.openTermWindow(this.testUrl)
    },

    async rawPdfContent () {
      // EnhancedPdfViewer에서 PDF를 렌더링하므로 여기서는 아무것도 하지 않음
      // 부모 컴포넌트에서 호출하는 메서드이므로 존재해야 함
    },
    handleError (error) {
      console.error('PDF 뷰어 에러:', error)
      // 에러 처리 로직 추가
    }
  }
}
</script>
<style>
@import "https://unpkg.com/vue-pdf-app@2.0.0/dist/icons/main.css";

/* vuePdf 설정 아이콘(...) 안보이게 하기*/
#secondaryToolbarToggle {
  display: none;
}

</style>
<style scoped>
select {
  /* -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;         */
  background-color: transparent; /* 배경 없애기 */
  border: 1px solid #ccc;        /* 원하면 테두리만 */
  padding: 4px 8px;
  font-size: 14px;
}
</style>
